<script setup lang="ts">
import SelectableList from "@/components/ui/SelectableList/SelectableList.vue";
import UserAvatar from "@/components/ui/UserAvatar/UserAvatar.vue";
import type { AuthUser } from "@/model/user";

defineProps<{ header?: string; modelValue?: AuthUser | AuthUser[]; values: AuthUser[] }>();

const emit = defineEmits<{ "update:model-value": [value: AuthUser | AuthUser[]] }>();
</script>

<template>
  <SelectableList
    v-keyboard-nav
    :header
    :model-value
    :values
    @update:model-value="emit('update:model-value', $event)"
  >
    <template #before="{ item }"><UserAvatar :user="item" /></template>
    <template #default="{ item }">{{ item.name }} </template>
  </SelectableList>
</template>
